import { ColData } from 'ufinet-web-components'
import { IntlShape } from 'react-intl'
import { commissionTypeMappings, CommissionType, CommissionMonth, commissionMonthMappings, CommissionCalculatingStatus, commissionCalculatingStatusMappings, CommissionTypeApproved, commissionTypeAprovedMappings } from 'types/typesAndValues';
import { ShowValue } from 'lib/showValue/ShowValue';
import MonthBadge from 'lib/badges/MonthBadge'
import { Translation } from 'utils/translation/Translation';
import { InProcessColDataTypes } from 'types/commissionKamTypes';
import { PercentangeCommission } from 'lib/percentangeCommission/PercentangeCommission';
import { RedirectLib } from 'lib/redirectLib/RedirectLib';


interface SelectItem {
  label: string
  value: string | number
}

interface Props {
  intl: IntlShape,
  dataType: SelectItem[],
  dataCommissionType: SelectItem[],
  dataCommissionDescription: SelectItem[],
  dataManagementType: any
  translation: any
  
}

export const colsInProcessCommission = ({intl, dataType, dataCommissionType, dataCommissionDescription, dataManagementType, translation}: Props): ColData[] =>  [
  // header is the id to search the translate based on the data received
  // removing or typing the word false in the property nonFilterable is gonna show in the table header the filter
  // body you can customize the data you want to show, accept react component or just a simple html
  { field: 'username', header: 'COL.CONFIG.NAME', width: '190px', nonFilterable: false, editable: false, filterType: 'text' },
  { field: 'quoteCode', header: 'COL.QUOTECODE', width: '190px', nonFilterable: false, editable: false, filterType: 'text' },
  { field: 'idService', header: 'COL.COMMISSION.ADMINCODE', width: '190px', nonFilterable: false, editable: false, filterType: 'text' },
  {
    field: 'idServiceCRM', header: 'COL.COMMISSION.IDSERVICECRM', width: '190px', nonFilterable: false, editable: false, filterType: 'number',
    body: (row: any) => <RedirectLib textToShow={row.service.idServiceCRM} redirectLink={row.service.serviceUrl} />
  },
  {
    field: 'type', header: 'COL.COMMISSION.TYPE', width: '190px', nonFilterable: false, editable: true, nonSortable: false, filterType: 'select',
    filterOptions: dataType || [],
    body: (row: InProcessColDataTypes) => <>{translation(row.commission.type)}</>
  },
  {
    field: 'managementType', header: 'COL.GLOBAL.MANAGEMENTTYPENAME', width: '190px', nonFilterable: false, editable: true, nonSortable: false, filterType: 'select', filterOptions: dataManagementType || [],
  },
  {
    field: 'backlog', header: 'COL.COMMISSION.BACKLOG', width: '190px', nonFilterable: true, editable: true, nonSortable: false,
    body: (row: InProcessColDataTypes) => <ShowValue value={row.service.backlog} currencyCode={row.service.currencyCode} />
  },
  {
    field: 'percentageCommission', header: 'COL.PERCENTGE.COMIISION.BASE', width: '190px', nonFilterable: true, editable: true, nonSortable: false,
    body: (row: InProcessColDataTypes) => <PercentangeCommission percentange={row.commission.percentageCommission} />
  },
  {
    field: 'percentageUser', header: 'COL.COMMISSION.PERCENTAGEUSER', width: '190px', nonFilterable: true, editable: true, nonSortable: false,
    body: (row: InProcessColDataTypes) => <PercentangeCommission percentange={row.commission.percentageUser} />
  },
  { field: 'exchangeRate', header: 'COL.COMMISSION.EXCHANGERATE', width: '190px', nonFilterable: true, editable: true, nonSortable: false },
  {
    field: 'baseAmount', header: 'COL.COMMISSION.BASEAMOUNT', width: '190px', nonFilterable: true, editable: true, nonSortable: false,
    body: (row: any) => <ShowValue value={row.commission.baseAmount} currencyCode={row.user.currencyCode} />
  },
  { field: 'saleYear', header: 'COL.COMMISSION.SALEYEAR', width: '190px', editable: false, nonFilterable: true, nonSortable: false, filterType: "select", },
  {
    field: 'saleMonth',
    header: 'COL.COMMISSION.SALEMONTH',
    width: '190px',
    nonFilterable: false,
    nonSortable: false,
    filterType: "select",
    filterOptions: [
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.JANUARY) }),
        value: CommissionMonth.JANUARY,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.FEBRUARY) }),
        value: CommissionMonth.FEBRUARY,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.MARCH) }),
        value: CommissionMonth.MARCH,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.APRIL) }),
        value: CommissionMonth.APRIL,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.MAY) }),
        value: CommissionMonth.MAY,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.JUNE) }),
        value: CommissionMonth.JUNE,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.JULY) }),
        value: CommissionMonth.JULY,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.AUGUST) }),
        value: CommissionMonth.AUGUST,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.SEPTEMBER) }),
        value: CommissionMonth.SEPTEMBER,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.OCTOBER) }),
        value: CommissionMonth.OCTOBER,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.NOVEMBER) }),
        value: CommissionMonth.NOVEMBER,
      },
      {
        label: intl.formatMessage({ id: commissionMonthMappings.get(CommissionMonth.DECEMBER) }),
        value: CommissionMonth.DECEMBER,
      },
    ],
    editable: true,
    body: (row: InProcessColDataTypes) => <MonthBadge month={row.saleMonth} />
  },
  {
    field: 'commissionType', header: 'COL.COMMISSION.COMMISSIONTYPE', width: '190px', nonFilterable: false, nonSortable: false, filterType: "select",
    filterOptions: dataCommissionType || [],
    editable: true,
    // body: (row: InProcessColDataTypes) => <>{translation(row.commissionType)}</>,
    //
  },
  {
    field: 'commissionTypePercentage', header: 'COL.COMMISSION.TYPEPERCENTAGE', width: '190px', nonFilterable: true, editable: true, nonSortable: false,
    body: (row: InProcessColDataTypes) => <PercentangeCommission percentange={row.commission.commissionTypePercentage} />,
  },
  {
    field: 'commissionDescription', header: 'COL.COMMISSION.STATUSCALCULATING', width: '190px', nonFilterable: false, nonSortable: false,
    filterOptions: dataCommissionDescription || [],
    // body: (row: InProcessColDataTypes) => <>{translation(row.commissionDescription)}</>,
    editable: true,
  },
  { field: 'serviceName', header: 'COL.COMMISSION.SERVICENAME', width: '190px', nonFilterable: false, editable: false, filterType: 'text' },
  { field: 'serviceClient', header: 'COL.COMMISSION.SERVICECLIENT', width: '190px', nonFilterable: false, editable: false, filterType: 'text' },
]
